import denialCodes from "../../contracts/suppressed-feature-denial-codes.json" with {
  type: "json",
};

export type SuppressedFeatureDenialCode = (typeof denialCodes)[number];

export const SUPPRESSED_FEATURE_DENIAL_CODES = new Set<string>(denialCodes);

export function isSuppressedFeatureDenialCode(
  value: unknown,
): value is SuppressedFeatureDenialCode {
  return (
    typeof value === "string" &&
    SUPPRESSED_FEATURE_DENIAL_CODES.has(value.trim())
  );
}
